import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import hasFeature from 'modules/core/lib/hasFeature'

import Card from 'modules/app_store/components/Card'
import { isAtsSuscriptionAddon } from 'modules/ats/lib/utils/integrations'
import subscriptionAddons from 'modules/billing/store/collections/subscriptionAddons'

import UpgradePlanBanner from './UpgradePlanBanner'
import styles from './index.module.scss'

const AppsList = () => {
  const { apps } = subscriptionAddons

  const {
    company: { id: companyId },
  } = useCurrentSession()

  return (
    <>
      <UpgradePlanBanner />
      <div className={styles.list} data-testid="app-list">
        {apps.map((subscriptionAddon) => {
          const { available_for_current_plan, enabled, id } = subscriptionAddon.attributes

          if (
            (id === 'competencies_custom_table' && !enabled) ||
            (id === 'growth_plans_custom_table' && !enabled) ||
            (id === 'trainings_custom_table' && !enabled) ||
            (id === 'space_control' && !hasFeature('dev_space_control')) ||
            (id === 'enps' && !available_for_current_plan && companyId !== 1) ||
            isAtsSuscriptionAddon(id)
          ) {
            return null
          }

          return (
            <Card key={subscriptionAddon.attributes.id} subscriptionAddon={subscriptionAddon} />
          )
        })}
      </div>
    </>
  )
}

export default AppsList
